var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 6.5C4 6.10218 4.15804 5.72064 4.43934 5.43934C4.72064 5.15804 5.10218 5 5.5 5H14.5C14.8978 5 15.2794 5.15804 15.5607 5.43934C15.842 5.72064 16 6.10218 16 6.5V12.5C16 12.8978 15.842 13.2794 15.5607 13.5607C15.2794 13.842 14.8978 14 14.5 14H5.5C5.10218 14 4.72064 13.842 4.43934 13.5607C4.15804 13.2794 4 12.8978 4 12.5V6.5ZM5.5 5.75C5.30109 5.75 5.11032 5.82902 4.96967 5.96967C4.82902 6.11032 4.75 6.30109 4.75 6.5V6.66275L10 9.81275L15.25 6.66275V6.5C15.25 6.30109 15.171 6.11032 15.0303 5.96967C14.8897 5.82902 14.6989 5.75 14.5 5.75H5.5ZM15.25 7.53725L11.719 9.656L15.25 11.8287V7.53725ZM15.2245 12.6942L10.9945 10.091L10 10.6873L9.0055 10.091L4.7755 12.6935C4.81812 12.8531 4.91224 12.9942 5.04324 13.0948C5.17425 13.1954 5.33481 13.25 5.5 13.25H14.5C14.6651 13.25 14.8256 13.1956 14.9566 13.0951C15.0876 12.9946 15.1817 12.8537 15.2245 12.6942ZM4.75 11.8287L8.281 9.656L4.75 7.53725V11.8287Z",
    fill: "#111723"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.5183bf915def79f14f3b4c39be306037.svg";
export { ForwardRef as ReactComponent };